// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"06b9d1db","559":"06b9d1db","560":"6cf77b70","714":"6cf77b70","873":"06b9d1db","883":"06b9d1db","885":"06b9d1db"}[chunkId] + ".chunk.css";
};